import { ImageFallbackComponent } from './image-fallback.component';

export const ImageFallbackModule = angular
  .module('sfMobile.components.imageFallback', [
    'pascalprecht.translate',
    'sfMobile.templates',
    'sfMobile.constants.tags',
  ])
  .component('sfImageFallback', ImageFallbackComponent).name;
